/* eslint-disable no-unused-vars */
export enum routeEnum {
  FallBack = "*",
  Home = "/",
  OrganisationInfo = "/organisation-info/:clubId",
  ResetPassword = "/auth/register/reset-password/:userId/:verificationCode",
  UserInfo = "/user",
  InvitationExpiry = "invitationExpiry",
  VerifyInvitation = "auth/register/verify-invitation/:invitationId",
  Info = "info",
  CookiePolicy = "cookie-policy",
}

export enum organisationEnum {
  Booking = "booking",
  ContactPerson = "/contact-person",
  Info = "info",
}

export enum supportEnum {
  Auth = "/auth/register/verify-email/",
  Booking = "/booking",
  ContactPerson = "/contact-person",
  Info = "/info",
  Member = "/user/member",
  OrganisationInfo = "/organisation-info",
  Reservations = "/user/reservations",
  Units = "/units",
  UserInfo = "/user/info",
  loginUser = "/login",
  refresh = "/login/refresh",
}

export enum userInfoEnum {
  Info = "info",
  Member = "member",
  Reservations = "reservations",
  UserInfo = "user/info",
}

export const route = { routeEnum };
